import React from 'react';

import './index.scss';

import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import {
    getChoiceLabel,
    getChoiceValues,
}from 'utils';

const SpTypeItem = ({ 
    title,
    text,
    isAllCheck,
    allCheckOnChange,
    typeState,
    stateOnChange,
}) =>{
    const listValues = getChoiceValues(title);
    return(
    <div className="SpTypeItem">
        <div className="STI-title">
            {text}
        </div>
        <div className="STI-allCheck">
            <NormalCheckBoxInput
                checked={isAllCheck}
                key={title}
                id={title}
                label='すべて'
                onChange={allCheckOnChange}
                value={isAllCheck}
                color="0"
            />
        </div>
        <div className="STI-input">
            {listValues.map((value) => {
                const choicelabel = getChoiceLabel(title, value);
                return (
                <NormalCheckBoxInput
                    checked={typeState.includes(value)}
                    key={choicelabel}
                    id={choicelabel}
                    label={choicelabel}
                    onChange={stateOnChange}
                    value={value}
                    color="0"
                />
                );
            })}
        </div>
        <div className="STI-horizon"></div>
    </div>
    );
}
export default SpTypeItem;